export const FETCH_ALL_SUPPLIER_TYPE_REQUEST = 'FETCH_SUPPLIER_TYPE_REQUEST';
export const FETCH_ALL_SUPPLIER_TYPE_SUCCESS = 'FETCH_SUPPLIER_TYPE_SUCCESS';
export const FETCH_ALL_SUPPLIER_TYPE_FAILURE = 'FETCH_SUPPLIER_TYPE_FAILURE';

export const FETCH_SUPPLIER_CATEGORY_TYPE_REQUEST = 'FETCH_SUPPLIER_CATEGORY_TYPE_REQUEST';
export const FETCH_SUPPLIER_CATEGORY_TYPE_SUCCESS = 'FETCH_SUPPLIER_CATEGORY_TYPE_SUCCESS';
export const FETCH_SUPPLIER_CATEGORY_TYPE_FAILURE = 'FETCH_SUPPLIER_CATEGORY_TYPE_FAILURE';

export const FETCH_STRENGTH_REQUEST = 'FETCH_STRENGTH_REQUEST';
export const FETCH_STRENGTH_SUCCESS = 'FETCH_STRENGTH_SUCCESS';
export const FETCH_STRENGTH_FAILURE = 'FETCH_STRENGTH_FAILURE';

export const FETCH_ADDITIONAL_STRENGTH_REQUEST = 'FETCH_ADDITIONAL_STRENGTH_REQUEST';
export const FETCH_ADDITIONAL_STRENGTH_SUCCESS = 'FETCH_ADDITIONAL_STRENGTH_SUCCESS';
export const FETCH_ADDITIONAL_STRENGTH_FAILURE = 'FETCH_ADDITIONAL_STRENGTH_FAILURE';

export const FETCH_COUNTRY_REQUEST = 'FETCH_COUNTRY_REQUEST';
export const FETCH_COUNTRY_SUCCESS = 'FETCH_COUNTRY_SUCCESS';
export const FETCH_COUNTRY_FAILURE = 'FETCH_COUNTRY_FAILURE';

export const FETCH_CITY_REQUEST = 'FETCH_CITY_REQUEST';
export const FETCH_CITY_SUCCESS = 'FETCH_CITY_SUCCESS';
export const FETCH_CITY_FAILURE = 'FETCH_CITY_FAILURE';

export const FETCH_SUPPLIER_DETAILS_REQUEST = 'FETCH_SUPPLIER_DETAILS_REQUEST';
export const FETCH_SUPPLIER_DETAILS_SUCCESS = 'FETCH_SUPPLIER_DETAILS_SUCCESS';
export const FETCH_SUPPLLIER_DETAILS_FAILURE = 'FETCH_SUPPLIER_DETAILS_FAILURE';

export const FETCH_SUPPLIER_PHOTO_GALLAREY_REQUEST = 'FETCH_SUPPLIER_PHOTO_GALLAREY_REQUEST';
export const FETCH_SUPPLIER_PHOTO_GALLAREY_SUCCESS = 'FETCH_SUPPLIER_PHOTO_GALLAREY_SUCCESS';
export const FETCH_SUPPLIER_PHOTO_GALLAREY_FAILURE = 'FETCH_SUPPLIER_PHOTO_GALLAREY_FAILURE';

export const FETCH_SUPPLIER_CERTIFICATES_REQUEST = 'FETCH_SUPPLIER_CERTIFICATES_REQUEST';
export const FETCH_SUPPLIER_CERTIFICATES_SUCCESS = 'FETCH_SUPPLIER_CERTIFICATES_SUCCESS';
export const FETCH_SUPPLIER_CERTIFICATES_FAILURE = 'FETCH_SUPPLIER_CERTIFICATES_FAILURE';

export const FETCH_SUPPLIER_REVIEW_SUMMARIES_REQUEST = 'FETCH_SUPPLIER_REVIEW_SUMMARIES_REQUEST';
export const FETCH_SUPPLIER_REVIEW_SUMMARIES_SUCCESS = 'FETCH_SUPPLIER_REVIEW_SUMMARIES_SUCCESS';
export const FETCH_SUPPLIER_REVIEW_SUMMARIES_FAILURE = 'FETCH_SUPPLIER_REVIEW_SUMMARIES_FAILURE';

export const FETCH_SUPPLIER_REVIEWS_REQUEST = 'FETCH_SUPPLIER_REVIEWS_REQUEST';
export const FETCH_SUPPLIER_REVIEWS_SUCCESS = 'FETCH_SUPPLIER_REVIEWS_SUCCESS';
export const FETCH_SUPPLIER_REVIEWS_FAILURE = 'FETCH_SUPPLIER_REVIEWS_FAILURE';

export const FETCH_MORE_USERS_REVIEWS_REQUEST = 'FETCH_MORE_USERS_REVIEWS_REQUEST';
export const FETCH_MORE_USERS_REVIEWS_SUCCESS = 'FETCH_MORE_USERS_REVIEWS_SUCCESS';
export const FETCH_MORE_USERS_REVIEWS_FAILURE = 'FETCH_MORE_USERS_REVIEWS_FAILURE';

export const FETCH_ALL_SUPPLIERS_MATERIALS_REQUEST = 'FETCH_ALL_SUPPLIERS_MATERIALS_REQUEST';
export const FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS = 'FETCH_ALL_SUPPLIERS_MATERIALS_SUCCESS';
export const FETCH_ALL_SUPPLIERS_MATERIALS_FAILURE = 'FETCH_ALL_SUPPLIERS_MATERIALS_FAILURE';
export const FETCH_MORE_ALL_SUPPLIERS_MATERIALS_SUCCESS = 'FETCH_MORE_ALL_SUPPLIERS_MATERIALS_SUCCESS';

export const FETCH_UNIT_TYPE_REQUEST = 'FETCH_UNIT_TYPE_REQUEST';
export const FETCH_UNIT_TYPE_SUCCESS = 'FETCH_UNIT_TYPE_SUCCESS';
export const FETCH_UNIT_TYPE_FAILURE = 'FETCH_UNIT_TYPE_FAILURE';

export const FETCH_SUPPLIER_MATERIAL_LIST_REQUEST = 'FETCH_SUPPLIER_MATERIAL_LIST_REQUEST';
export const FETCH_SUPPLIER_MATERIAL_LIST_SUCCESS = 'FETCH_SUPPLIER_MATERIAL_LIST_SUCCESS';
export const FETCH_SUPPLIER_MATERIAL_LIST_FAILURE = 'FETCH_SUPPLIER_MATERIAL_LIST_FAILURE';
export const FETCH_MORE_SUPPLIER_MATERIAL_LIST_SUCCESS = 'FETCH_MORE_SUPPLIER_MATERIAL_LIST_SUCCESS';

export const FETCH_SUPPLIER_SEARCH_SUCCESS = 'FETCH_SUPPLIER_SEARCH_SUCCESS';
export const FETCH_SUPPLIER_SEARCH_FAILURE = 'FETCH_SUPPLIER_SEARCH_FAILURE';

export const FETCH_SUPPLIER_LIST_SUCCESS = 'FETCH_SUPPLIER_LIST_SUCCESS';
export const FETCH_MORE_SUPPLIER_LIST_SUCCESS = 'FETCH_MORE_SUPPLIER_LIST_SUCCESS';
export const FETCH_SUPPLIER_LIST_FAILURE = 'FETCH_SUPPLIER_LIST_FAILURE';
export const FETCH_SEARCH_RESULT_SUPPLIERS_MATERIALS = 'FETCH_SEARCH_RESULT_SUPPLIERS_MATERIALS';
export const FETCH_FABRIC_SEARCH_SUCCESS = 'FETCH_FABRIC_SEARCH_SUCCESS';
export const GET_SEARCH_VALUE = 'GET_SEARCH_VALUE';
export const IS_DESCRIPTION_SEARCH_OPEN = 'IS_DESCRIPTION_SEARCH_OPEN';
export const GET_DESCRIPTION_SEARCH_TEXT = 'GET_DESCRIPTION_SEARCH_TEXT';
